import { IMilestone } from "@mctypes/global.types";
import { Card, Paper, Stack, Text, Title } from "@mantine/core";
import { ColDef } from "ag-grid-community";
import React from "react";
import ViewEditTable from "../../../components/ViewEditTable/ViewEditTable";
import { VETEmptyValidator } from "../../../components/ViewEditTable/ViewEditTableValidators";
import { setShowSuccessMessageThunk } from "../../../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { ToastMessagesEnums } from "@mcapps/shared/sharedConstants";
import { setMilestonesInRedux } from "../../actions";
import { doUpdateMilestones } from "./restQueries";

const ProjectMilestoneSettingsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const project = useAppSelector((state) => state.adminReducer.project);

  const updateMilestones = async (milestones: IMilestone[]) => {
    const _milestones = await doUpdateMilestones(project._id, milestones);
    dispatch(setMilestonesInRedux(_milestones));
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
  };

  const columns: ColDef<IMilestone>[] = [
    {
      field: "name",
      headerName: "Navn",
      editable: true,
    },
    {
      field: "description",
      headerName: "Beskrivelse",
      editable: true,
    },
    {
      field: "dueDate",
      headerName: "Frist",
      editable: true,
      cellDataType: "dateString",
    },
  ];

  const newItemTemplateObject: IMilestone = {
    _id: null,
    name: "",
    description: "",
    dueDate: "",
  };

  return (
    <Card withBorder p="md">
      <Stack gap="sm">
        <Title order={4}>Milepæler</Title>
        <Text size="sm" c="dimmed">
          Administrer milepæler for prosjektet.
        </Text>
        <ViewEditTable
          validators={[VETEmptyValidator, VETEmptyValidator]}
          columns={columns}
          data={project.milestones || []}
          onSave={updateMilestones}
          newItemTemplateObject={newItemTemplateObject}
          canEdit={true}
        />
      </Stack>
    </Card>
  );
};

export default ProjectMilestoneSettingsPage;
